<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'SERVIDORALFRESCO.LBL_SISTEMAS' | translate}}">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <form #fr="ngForm" [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{'SERVIDORALFRESCO.LBL_NOMBREALFRESCO' | translate}}</label>
                <input [maxLength]="150" pInputText appTexto formControlName="nombre" name="nomNombreAlfresco"
                  id="idNombreAlfresco" required="true" type="text">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'SERVIDORALFRESCO.LBL_NOMBREALFRESCO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{'SERVIDORALFRESCO.LBL_RUTAALFRESCO' | translate}}</label>
                <input [maxLength]="500" pInputText appTexto formControlName="ruta" name="nomNombreAlfresco"
                  id="idNombreAlfresco" required="true" type="text" *ngIf="!servidorAlfresco">
                <label class="falso-combo-texto" *ngIf="servidorAlfresco">{{servidorAlfresco.ruta}}</label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.ruta.invalid">
                  {{ 'SERVIDORALFRESCO.LBL_RUTAALFRESCO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <div>
                  <p-checkbox id="indicadorHabilitado" name="nomIndicadorHabilitado" formControlName="indicadorHabilitado"
                    binary="true">
                  </p-checkbox>
                  <label class="pl-2">{{ 'LBL_HABILITADO' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="cancelar((fr.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
        <p-confirmDialog #cd>
          <p-footer>
            <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate}}"
              (click)="cd.reject()"></button>
            <button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate}}"
              (click)="cd.accept()"></button>
          </p-footer>
        </p-confirmDialog>
      </div>
    </div>
  </p-panel>
</div>
